import styled from 'styled-components';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import Button from '../../Button';

export const MenuPillButton = styled(Button)`
  border: none;
  border-radius: 999px;
  padding-left: 12px;

  &:hover {
    border: none;
  }
`;

export const MenuPillChevron = styled(KeyboardArrowDownRoundedIcon)<{
  $isOpen: boolean;
}>`
  font-size: 16px;
  transition: transform 0.2s ease;
  transform: rotate(${({ $isOpen }) => ($isOpen ? '-90deg' : '0deg')});
`;
